import React, { useEffect } from 'react'
import CustomModal from '../../baseComponents/gui/customModal/CustomModal'
import { safeHTML } from '../../../utils/safeHTML'
import CustomButton from '../../features/customButton/ui/main/CustomButton'
import { useModal } from '../../../hooks/useModal'
import { compilationScrollbarSettings } from '../../../constants/copyright'
import { Scrollbar } from 'react-scrollbars-custom'
import { image } from '../../../utils/data/baseUrl'
import { useContent, useProducts } from '../../../redux/reducer/content'
import classNames from 'classnames'
import { gameResultModalContent } from '../../../constants/copyright-modals'
import Product from '../../features/product'
import GameResultModalReward from './gameResultModalReward/GameResultModalReward'
import GameResultModalRating from './gameResultModalRating/GameResultModalRating'
import { useOpen } from '../../../hooks/useOpen'
import { useTranslation } from '../../../translations'
import useGetProductsAndClear from '../../features/product/model/hooks/useGetProductsAndClear'
import AppLoader from '../../features/appLoader/AppLoader'
import { useModalsDataActions } from '../../../hooks/useModalsDataActions'
import useServiceData from '../../../hooks/useServiceData'
import { isAlfaGameActive } from '../../../utils/game/isAlfaGameActive'
import { getProductCurrentState } from '../../features/product/utils/getProductCurrentState'
import { gtmFunctions } from '../../../constants/analytics/GTM'

const { title, buttons, rating, count } = gameResultModalContent

const GameResultModal = React.forwardRef(function GameResultModal(
  { callbacks, buttonLink, gameType, toGames, coins, xp, score },
  ref,
) {
  const { buyProducts, productsFromGA } = useProducts()
  const [getProducts, isPendingProducts] = useGetProductsAndClear()
  const { closeModal } = useModal()
  const { t } = useTranslation()
  const openLink = useOpen()
  const buttonsCallbacks = { toGames }
  const { addModal } = useModalsDataActions()
  const { get, save } = useServiceData()
  const { state } = useContent()
  const { isGameState, gameName } = getProductCurrentState(state)

  const MAX_SHOWS_ALFA_COUNT = 2

  const showAlfaBankModal = () => {
    const alfaBankModalShowCount = get('alfaBankModalShowCount')
    const count = alfaBankModalShowCount ? parseInt(alfaBankModalShowCount, 10) : 0

    if (gameType === 'Runner' && isAlfaGameActive() && count < MAX_SHOWS_ALFA_COUNT) {
      save('alfaBankModalShowCount', count + 1)

      addModal({
        id: 'onboardingModal',
        type: 'onboardingModal',
        props: {
          image: image('alfaBank/modal.png'),
          title: 'alfaBankGame.modalTitle',
          description: 'alfaBankGame.modalDescription',
          buttons: [
            {
              attr: {
                text: 'alfaBankGame.modalButton',
                tag: 'a',
                isLink: true,
                target: '_blank',
                href: 'https://alfa.me/fI_IXg',
                modalData: {
                  action: 'close',
                  data: { type: 'current' },
                },
              },
            },
            {
              attr: {
                text: 'other.backToGame',
                disposable: true,
                className: 'custom-button_gray',
                modalData: { action: 'close', data: { type: 'current' } },
              },
            },
          ],
        },
      })
    }
  }

  const buttonClick = (button) => {
    if (button?.isLink) {
      openLink(buttonLink)

      if (isGameState) {
        gtmFunctions.GTMGamesShop({
          name: gameName,
        })
      }

      return
    }

    if (button?.action) {
      buttonsCallbacks?.[button.action]?.()
      closeModal({ type: 'all' })

      if (isGameState) {
        gtmFunctions.GTMGamesReturn({
          name: gameName,
        })
      }

      showAlfaBankModal()
    }
  }

  useEffect(() => {
    getProducts(
      buyProducts?.reduce((acc, { game_type, sku }) => {
        game_type === gameType && acc.push(sku)
        return acc
      }, []),
    )
  }, [])

  return (
    <CustomModal animation={['fade', 'scale', 'scale-bounce']}>
      <div
        className={classNames(`game-result-modal`, {
          'game-result-modal_scroll': !!productsFromGA?.length,
        })}
        ref={ref}
      >
        <div className='game-result-modal__content'>
          {!!productsFromGA?.length ? (
            <Scrollbar {...compilationScrollbarSettings}>{content()}</Scrollbar>
          ) : (
            content()
          )}
        </div>
      </div>
      {isPendingProducts && <AppLoader />}
    </CustomModal>
  )

  function content() {
    return (
      <>
        <GameResultModalRating
          count={count}
          {...rating}
          callbacks={callbacks}
          gameType={gameType}
          userScore={score}
        />

        {(!!coins || !!score) && (
          <div className='game-result-modal__prizes'>
            <div className='game-result-modal__prizes-title'>
              {t('gameResultModalContent.result')}
            </div>
            <div className='game-result-modal__prizes-list'>
              {!!coins && (
                <GameResultModalReward
                  type={'coin'}
                  value={coins}
                />
              )}
              {!!xp && (
                <GameResultModalReward
                  type={'xp'}
                  value={xp}
                />
              )}
              {!!score && (
                <GameResultModalReward
                  type={'prize'}
                  value={score}
                />
              )}
            </div>
          </div>
        )}

        {!!productsFromGA?.length && (
          <div className={classNames('game-result-modal__more')}>
            <img
              src={image('procedureResult/arrow.svg')}
              className={'game-result-modal__arrow'}
              alt={''}
            />
            <div className='game-result-modal__selection quiz-win-modal__selection quiz-win-modal__selection_products'>
              <div className='game-result-modal__selection-title'>{safeHTML(t(title))}</div>
              <div className='game-result-modal__selection-list'>
                {productsFromGA?.map?.((item, index) => (
                  <Product
                    {...item}
                    key={`product-${index}`}
                    className={'product_quiz product_quiz-gray'}
                    noCode={true}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        <div className={'game-result-modal__buttons'}>
          {buttons.map((button, i) => (
            <CustomButton
              key={i}
              {...button}
              onClick={() => buttonClick(button)}
            />
          ))}
        </div>
      </>
    )
  }
})
export default GameResultModal
GameResultModal.propTypes = {}
